import { getUA, deviceType } from 'react-device-detect';
import TagManager from 'react-gtm-module';
import 'url-search-params-polyfill';

export default {
  track: (pageType, eventLabel, eventTarget) => {
    const urlParams = new URLSearchParams(typeof window !== 'undefined' && window.location.search);

    const tagManagerArgs = {
      dataLayer: {
        event: 'hm_push_event',
        event_category: 'Product-Engagement',
        event_action: 'Click',
        event_label: `Label= ${eventLabel}`,
        origin_target: `${eventTarget}`,
        state: urlParams.get('state'),
        client_id: urlParams.get('client'),
        device_type: deviceType,
        page_type: pageType,
        user_agent: getUA,
        referrer: document.referrer,
      },
    };
    TagManager.dataLayer(tagManagerArgs);
  },
};
